import { HubConnectionBuilder } from "@microsoft/signalr";
import React, { createContext, useContext, useEffect, useState } from "react";
import { appConst } from "../AppConst";
import { useAuth } from "../hooks/useAuth";

type HubContextType = {
    children: React.ReactNode
}

type HubStoreType = {
    _connectionServer: any
}

const HubContext = createContext({} as HubStoreType);
const useHubContext = () => useContext(HubContext);
const reConnectTime: number = 5000;

const HubProvider = ({ children }: HubContextType) => {
    const { user } = useAuth();
    const [connectionServer, setConnectionServer] = useState<any>(null);
    const [isConnected, setIsConnected] = useState(false);
    const userId = user?.id ?? user?.sub;

    const store: HubStoreType = {
        _connectionServer: connectionServer
    }

    useEffect(() => {
        if (!userId) {
            setConnectionServer(null);
            return;
        }

        const domain = appConst.baseApiURL.includes("http") ? appConst.baseApiURL.replace("/api", "") : window.location.origin;
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${domain}/hubs/process?userId=${encodeURIComponent(String(userId))}`)
            .withAutomaticReconnect()
            .build();

        setConnectionServer(newConnection);
    }, [userId, user]);

    useEffect(() => {
        if (!connectionServer) {
            return;
        }

        let intervalId: ReturnType<typeof setInterval> | null = null;
        let disposed = false;

        const startConnection = async () => {
            try {
                await connectionServer.start();
                if (!disposed) {
                    setIsConnected(true);
                }
            } catch (e: any) {
                console.log('connectionServer failed: ', e);

                intervalId = setInterval(async () => {
                    try {
                        await connectionServer.start();
                        if (!disposed) {
                            setIsConnected(true);
                        }

                        if (intervalId) {
                            clearInterval(intervalId);
                            intervalId = null;
                        }
                    } catch {
                    }
                }, reConnectTime);
            }
        };

        startConnection();

        return (() => {
            disposed = true;

            if (intervalId) {
                clearInterval(intervalId);
            }

            connectionServer.stop();
            setIsConnected(false);
        });
    }, [connectionServer]);

    return (
        <HubContext.Provider value={store}>
            {children}
        </HubContext.Provider>
    );
}
export {
    HubProvider,
    useHubContext
};

